var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"fill-height",attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"align":"center"}},[_c('v-img',{attrs:{"src":"android-chrome-192x192.png","aspect-ratio":"1","height":"100px","width":"100px"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }